import { render, staticRenderFns } from "./JediCommunityPledge.vue?vue&type=template&id=713ce52a&scoped=true&"
import script from "./JediCommunityPledge.vue?vue&type=script&lang=js&"
export * from "./JediCommunityPledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713ce52a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('713ce52a')) {
      api.createRecord('713ce52a', component.options)
    } else {
      api.reload('713ce52a', component.options)
    }
    module.hot.accept("./JediCommunityPledge.vue?vue&type=template&id=713ce52a&scoped=true&", function () {
      api.rerender('713ce52a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/register/components/jedi/JediCommunityPledge.vue"
export default component.exports